enum InterestPaymentMethodEnum {
    Custom = 'CUSTOM',
    Monthly = 'MONTHLY',
    Prepaid = 'PREPAID',
}

export default InterestPaymentMethodEnum;
